import { useSuspenseQuery } from "@tanstack/react-query";
import { orderHistoryClaimApi } from "@/features/my-order/features/order-history/features/claim/api";
import useIdentity from "@/features/ui/hooks/use-identity";
import { companyTypeRequestFormatConverter } from "@/utils/converter";
import useOrderHistoryDetail from "@/features/my-order/features/order-history/hooks/useOrderHistoryDetail";
import { toCamelKeyObject } from "@/utils/case";
import { GetClaimDetailResponse } from "@/features/my-order/features/order-history/features/claim/types";

const useGetClaimDetail = (userRequestDetailId?: number) => {
  const identity = useIdentity();
  const { orderSheetSetId } = useOrderHistoryDetail();

  const companyType =
    companyTypeRequestFormatConverter[identity?.company?.type ?? "BUYER"];
  const companyId = identity?.company?.id;

  const canFetch =
    orderSheetSetId && companyId && companyType && userRequestDetailId;

  const { data } = useSuspenseQuery({
    queryKey: [
      "order-history",
      "claim-detail",
      companyType,
      companyId,
      orderSheetSetId,
      userRequestDetailId,
    ],
    queryFn: () => {
      if (!canFetch) {
        return Promise.reject(new Error("Missing required parameters"));
      }
      return orderHistoryClaimApi.getClaimDetail(
        companyType,
        companyId,
        orderSheetSetId,
        userRequestDetailId
      );
    },
    select: (data) => toCamelKeyObject(data) as GetClaimDetailResponse,
  });

  return { data };
};

export default useGetClaimDetail;
